import { Helmet } from "react-helmet-async";

const SITE = "https://skedaddlejunk.com";

export default function Seo({ title, titleFull, description, path = "/", jsonLd, image = "/og-banner.png", noindex = false }) {
  const url = `${SITE}${path}`;
  const fullTitle = titleFull ? titleFull : title ? `${title} | Skedaddle Junk Removal` : "Junk Removal in Charleston, SC | Skedaddle Junk Removal";
  const webPage = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: fullTitle,
    url,
    ...(description ? { description } : {}),
    isPartOf: { "@type": "WebSite", name: "Skedaddle Junk Removal", url: SITE },
    publisher: { "@id": `${SITE}/#business` },
  };
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content={noindex === "follow" ? "noindex, follow" : "noindex, nofollow"} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${SITE}${image}`} />
      <meta name="twitter:card" content="summary_large_image" />
      <script type="application/ld+json">{JSON.stringify(webPage)}</script>
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export const localBusinessLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE}/#business`,
  name: "Skedaddle Junk Removal",
  url: SITE,
  telephone: "+1-843-518-0021",
  image: `${SITE}/og-banner.png`,
  logo: `${SITE}/mascot.png`,
  priceRange: "$$",
  description: "Skedaddle Junk Removal is an insured junk hauling company based in Charleston, South Carolina. We remove furniture, appliances, mattresses, yard debris, and whole cleanouts across the Lowcountry, usually same day or next day.",
  address: { "@type": "PostalAddress", addressLocality: "Charleston", addressRegion: "SC", addressCountry: "US" },
  geo: { "@type": "GeoCoordinates", latitude: 32.7765, longitude: -79.9311 },
  openingHoursSpecification: [{
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    opens: "08:00", closes: "18:00",
  }],
  sameAs: ["https://www.facebook.com/skedaddlejunkremoval", "https://www.google.com/maps?cid=8262576848428075917"],
  areaServed: [
    "Charleston", "North Charleston", "Mount Pleasant", "West Ashley", "Daniel Island", "Park Circle",
    "Summerville", "Goose Creek", "Hanahan", "Ladson", "Moncks Corner", "Bonneau", "Cane Bay", "Nexton",
    "Carnes Crossroads", "Lincolnville", "Johns Island", "James Island", "Folly Beach", "Isle of Palms",
    "Sullivan's Island", "Kiawah Island", "Seabrook Island", "Wadmalaw Island", "Edisto Island", "Awendaw",
    "McClellanville", "Ravenel", "Hollywood", "Meggett",
  ].map((n) => ({ "@type": "City", name: n, address: { "@type": "PostalAddress", addressLocality: n, addressRegion: "SC", addressCountry: "US" } })),
};
